import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useCustomerContext } from "../../../../utils/customerContext";
import { useInvoiceContext } from "../../../../utils/invoiceContext";

function CuDeInvoice({ id }) {
    const { fetchCustomerSlug, customerSlug } = useCustomerContext();
    const { fetchCustomerInvoices, customerInvoices } = useInvoiceContext();

    useEffect(() => {
        if (id) {
            fetchCustomerSlug(id);
        }
    }, [id]);

    useEffect(() => {
        if (customerSlug && customerSlug._id) {
            fetchCustomerInvoices(customerSlug._id);
        }
    }, [customerSlug?._id]);

    return (
        <div className="cudeContentContainer">
            <div className="cudeHeadingContainer"><h3>Rechnungen</h3></div>
            <p>Für den Kunden hast du {customerInvoices?.length || 0} {customerInvoices?.length === 1 ? 'Rechnung.' : 'Rechnungen.'}</p>
            
            <div className="cudeInvoiceContainer">
                {
                    customerInvoices.map((invoice) => (
                        <div key={invoice._id}>
                            <h4>{invoice.invoiceNumber}</h4>
                            {/* KORREKTUR: invoice._id statt customerInvoices._id */}
                            <Link to={`/dashboard/invoice/${invoice._id}`}>Zu der Rechnung</Link>
                        </div>
                    ))
                }
            </div>
            <p>Um eine neue Rechnung zu erstellen oder deine Rechnungen zu sehen klick <Link to='/dashboard/invoice'>hier</Link>.</p>
        </div>
    );
}

export default CuDeInvoice;